import type {ViewportConfig} from '@gongxigames/framework/core/types/ViewportConfig';
import type {Layers} from '@gongxigames/framework/core/types/Layers';
import type {Size2D} from '@gongxigames/framework/core/types/Size2D';

export type CoreGameConfig = {
    layers: Layers;

    /**
     * @deprecated
     * Slot v1 config for fixed size UI
    */
    mainFrame: Size2D;

    /**
     * @deprecated
     * Slot v1 config for fixed size UI
    */
    viewport: ViewportConfig;
};
